import { TFunction } from 'i18next';

import { NoteRevision } from 'shiftNotes/_types';

interface FormatRevisionEditorLabelArgs {
  t: TFunction;
  revision: NoteRevision;
  noteAuthorName: string;
  isNoteCreation: boolean;
  isCurrentUser: boolean;
}

export default function formatRevisionEditorLabel({
  t,
  revision,
  noteAuthorName,
  isNoteCreation,
  isCurrentUser,
}: FormatRevisionEditorLabelArgs): string {
  const isAiEdit =
    revision.source === 'ai_edit' || revision.source === 'processing';
  const editorName = isCurrentUser
    ? t('eventVersionHistory.you')
    : noteAuthorName;

  if (isAiEdit) {
    return isCurrentUser
      ? t('eventVersionHistory.aiMadeEdits')
      : t('eventVersionHistory.aiMadeEditsOthers', { name: noteAuthorName });
  }
  if (isNoteCreation) {
    return t('eventVersionHistory.created', { name: editorName });
  }
  return t('eventVersionHistory.madeEdits', { name: editorName });
}
